import { useMemo } from 'react'
import { buildMainLayoutPropsObject } from './buildMainLayoutPropsObject'

/** @param {object} m @param {object} handlers */
export function useMainLayoutProps(m, handlers) {
  const mainLayoutProps = useMemo(
    () => buildMainLayoutPropsObject(m, handlers),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- field-level deps match prior hook
    [
      m.activePrimaryKey,
      m.displayThreadId,
      m.activeMessages,
      handlers.handleSendMessage,
      m.chatComposerLocked,
      m.activeQueryVersionByExchangeId,
      m.activeAnswerVersionByExchangeId,
      handlers.setExchangeActiveQueryVersion,
      handlers.setExchangeActiveAnswerVersion,
      handlers.handleSendEditVersion,
      handlers.handleRegenerateAssistantVersion,
      m.mainAskBarPrefill,
      handlers.handleMainAskBarPrefill,
      handlers.agentQuestion?.activeAgentQuestion,
      handlers.agentQuestion?.handleAgentQuestionConfirm,
      handlers.voice,
      handlers.startHomeVoice,
      handlers.handleModelChange,
    ])
  return { mainLayoutProps }
}
